export default __webpack_public_path__ + "static/media/googleplay.407716d0.svg";